module.exports = "/_next/static/images/expert-michael-valverde-20cf8844d83ef28662af9e1988c5831d.png";